module.exports = __webpack_public_path__ + "img/1-3-baseplate-loughborough-guide.98a61c34.jpg";